import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withModifiers as _withModifiers, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6a573160"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"font-weight":"600"}
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 1,
  class: "text-center"
}

import { ref, computed, watch } from 'vue';
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserSelectorComponent',
  props: {
  users: Array,
  usersSearchText: String,
  selectAll: Boolean,
  deletedUsers: Boolean,
  showIncludeDeletedUsers: Boolean,
  row: Number,
  prefix: String,
  modelValue: Array,
  showLabel: { type: Boolean, default: true }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
const usersSearch = ref(props.usersSearchText);
const checkAllUsers = ref(props.selectAll);
const deletedUsers = ref(props.deletedUsers);
const selectedUsersData = ref(props.modelValue);
const router = useRouter();
const valueProps = ref(props.modelValue);

const userColProps = computed(() => {
  const cols = props.row === 1 ? 12 : Math.round(12 / props.row);
  return { cols: 12, md: cols };
});

const filteredUsers = computed(() => props.users.filter(user => user['username'].toLowerCase().includes(usersSearch.value?.toLowerCase())));

const checkAll = (status) => {
  checkAllUsers.value = status;
  selectedUsersData.value = status ? props.users.map(user => user['userId']) : [];
};

const getUserName = (name) => name.length > 29 ? `${name.substring(0, 29)}...` : name;

watch(usersSearch, () => {
  checkAllUsers.value = selectedUsersData.value.length === props.users.length;
});

watch(selectedUsersData, () => {
  checkAllUsers.value = selectedUsersData.value.length === props.users.length;
  emit('update:modelValue', selectedUsersData.value);
},{ deep: true });

function clearSearch() {
  usersSearch.value = '';
  checkAllUsers.value = valueProps.value.length === props.users.length;
}


return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!

  return (__props.users.length > 0)
    ? (_openBlock(), _createBlock(_component_v_row, {
        key: 0,
        class: "scroll"
      }, {
        default: _withCtx(() => [
          (__props.showLabel)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Filter users: ")
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                class: "bg-white",
                modelValue: usersSearch.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((usersSearch).value = $event)),
                label: "Type to begin filtering...",
                clearable: "",
                "onClick:clear": clearSearch,
                density: "compact",
                variant: "outlined",
                "hide-details": ""
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            class: "py-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_checkbox, {
                modelValue: checkAllUsers.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((checkAllUsers).value = $event)),
                label: "Select All",
                onChange: _cache[2] || (_cache[2] = ($event: any) => (checkAll(checkAllUsers.value))),
                density: "compact",
                "hide-details": ""
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }),
          (__props.showIncludeDeletedUsers)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 1,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    modelValue: deletedUsers.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((deletedUsers).value = $event)),
                    label: "Include Deleted Users",
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (!!deletedUsers.value)),
                    density: "compact",
                    "hide-details": ""
                  }, null, 8 /* PROPS */, ["modelValue"])
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredUsers.value, (user) => {
            return (_openBlock(), _createBlock(_component_v_col, _mergeProps({ ref_for: true }, userColProps.value, {
              cols: "12",
              class: "py-0"
            }), {
              default: _withCtx(() => [
                _createVNode(_component_v_checkbox, {
                  modelValue: selectedUsersData.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedUsersData).value = $event)),
                  value: user['userId'],
                  density: "compact",
                  "hide-details": ""
                }, {
                  label: _withCtx(() => [
                    (selectedUsersData.value.includes(user['userId']))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(getUserName(user['username'])), 1 /* TEXT */))
                      : (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(getUserName(user['username'])), 1 /* TEXT */)),
                    (__props.row > 1)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 2,
                          class: "mx-1",
                          size: "small",
                          icon: "mdi-pencil-box-outline",
                          onClick: _withModifiers(($event: any) => (_unref(router).push({name: 'account.user.edit', params: { userId: user['userId'] }})), ["prevent"])
                        }, null, 8 /* PROPS */, ["onClick"]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "value"])
              ]),
              _: 2 /* DYNAMIC */
            }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, "No Users to choose from."))
}
}

})